module.exports = __webpack_public_path__ + "static/media/sleeping.092797c8.gif";